<div class="body main-font">
    <div class="reset-password-form">
        <div class="content">
            <h1>Invia Email di recupero</h1>
                <form (ngSubmit)="sendEmail()" [formGroup]="resetPasswordForm">
                    <div class="wrap-input100 validate-input" data-validate="Email is required" data-failed="Wrong Email o Password">
                        <input class="input100" type="email" name="email" formControlName="email" placeholder="Email">
                        <span class="focus-input100"></span>
                        <span class="symbol-input100">
                            <fa-icon [icon]="faEnvelope"></fa-icon>
                        </span>
                    </div>
                    <div class="container-login100-form-btn">
                        <button type="submit" class="login100-form-btn">Verifica Email</button>
                    </div>
                </form>
            <div class="toaster toaster"*ngIf="sent">
                <p>Email inviata con successo!</p>
            </div>
            <div class="failed-toaster toaster" *ngIf="sent == false && submitted">
                <p>Email sbagliata</p>
            </div>
            <div class="loading-toaster toaster" *ngIf="sent == null && submitted">
                <p>Risposta dal server in corso</p>
            </div>
        </div>
    </div>
</div>